import { createSelector } from '@reduxjs/toolkit';

import { URL_PATH } from 'constants/index';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.erpSystem || initialState;
const createBasename = (state: RootState) => {
  return URL_PATH;
};

export const selectBasenamePath = createSelector(
  [createBasename],
  state => state,
);

export const selectErpSystemState = createSelector(
  [selectSlice],
  state => state,
);

export const selectErpSystem = createSelector(
  [selectSlice],
  state => state.erpSystem,
);

export const selectCustomerNumber = createSelector(
  [selectSlice],
  state => state.customerNumber,
);

export const selectLanguageId = createSelector(
  [selectSlice],
  state => state.languageId,
);

export const selectLanguage = createSelector(
  [selectSlice],
  state => state.language,
);

export const selectSalesOrganization = createSelector(
  [selectSlice],
  state => state.salesOrganization,
);

export const selectSalesDocumentNumber = createSelector(
  [selectSlice],
  state => state.salesDocumentNumber,
);

export const selectSalesDocumentPosition = createSelector(
  [selectSlice],
  state => state.salesDocumentPosition,
);

export const selectSapUserId = createSelector(
  [selectSlice],
  state => state.sapUserId,
);

export const selectCustomerLanguageCode = createSelector(
  [selectSlice],
  state => state.customerLanguageCode,
);

export const selectSapConfigurationNumber = createSelector(
  [selectSlice],
  state => state.sapConfigurationNumber,
);

export const selectConfigurationId = createSelector(
  [selectSlice],
  state => state.configurationId,
);

export const selectPlantCode = createSelector(
  [selectSlice],
  state => state.plantCode,
);
